import {unref} from 'vue'

/**
 * Document composable
 */
export function useDocument() {

  //Get document element
  const {documentElement} = document

  //Set document props
  const setDocumentTitle = title => document.title = unref(title)
  const setDocumentTheme = theme => {
    documentElement.classList.remove('app-theme-light', 'app-theme-dark')
    documentElement.classList.add(`app-theme-${theme}`)
  }

  //Expose interface
  return {
    setDocumentTitle,
    setDocumentTheme,
  }
}
